var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSaveForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13.418,
  height: 13.418,
  viewBox: "5.249 5.291 13.418 13.418"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10804",
  clipPath: "url(\"#a\")",
  fill: "#26890d",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.466 5.418a.384.384 0 0 0-.297-.127H5.672c-.254 0-.423.17-.423.423v12.572c0 .254.169.423.423.423h12.571c.254 0 .424-.17.424-.423V7.788a.384.384 0 0 0-.127-.296l-2.074-2.074Zm-7.196.72h5.46V9.48H9.27V6.138Zm6.518 11.724H8.254v-5.46h7.534v5.46Zm2.117 0h-1.27V11.98c0-.254-.17-.423-.423-.423H7.83c-.254 0-.424.169-.424.423v5.841h-1.27V6.095h2.286v3.767c0 .254.17.424.424.424h6.306c.254 0 .424-.17.424-.424V6.095h.465l1.863 1.863v9.904Z",
  "data-name": "Path 280433"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.905 14.519h4.19c.254 0 .424-.17.424-.424s-.17-.423-.424-.423h-4.19c-.254 0-.424.17-.424.423 0 .254.17.424.424.424",
  "data-name": "Path 280434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.905 16.593h4.19c.254 0 .424-.17.424-.424s-.17-.423-.424-.423h-4.19c-.254 0-.424.17-.424.423 0 .254.17.424.424.424",
  "data-name": "Path 280435"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  "data-name": "Rectangle 5569"
})))));
export default SvgSaveForm;